import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom';
import { NON_ERASABLE_TYPESDI_ID, ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import TableSorting from "pages/typesDIFormat/SortingTablesTypesDI"
import FormatGeneralDISettings from "pages/typesDIFormat/formatDIEdit/FormatOptionsDIGeneralSettings";
import FormatDISettings from "pages/typesDIFormat/formatDIEdit/FormatDISettings";
import FormatDetailsDISettings from "pages/typesDIFormat/formatDIEdit/FormatOptionsDISettings";
import PropTypes from 'prop-types';

const initialFilters= {
  "idFrom":"",
  "idTo":"",
  "codeFrom":"",
  "codeTo":"",
  "nameesFrom":"",
  "nameesTo":"",
  "nameenFrom":"",
  "nameenTo":"",
  "codeHexFrom":"",
  "codeHexTo":"",
  "codeCotGroupFrom":"",
	"codeCotGroupTo":"",
  "code_iso2From":"",
  "code_iso2To":"",
  "code_iso3From":"",
  "code_iso3To":"",
  "extphoneFrom":"",
  "extphoneTo":"",
  "extinternetFrom":"",
  "extinternetTo":"",
  "isEnabled":true,
  "isNotEnabled":true
};

const initialState = [{
  "id" : "",
  "namees" : "",
  "nameen" : "",
  "default_preiddoc_sheet" : "",
  "default_sufiddoc_sheet" : 0,
  "default_number_dt": "",
  "formatnumber":1,

  "default_opt_tras_id" : 0,
  "default_opt_tras_documnettype_id" : 0,
  "default_opt_tras_documentid" : "",
  "default_opt_tras_tradename" : "",
  "default_opt_tras_name" : "",
  "default_opt_tras_contactname" : "",
  "default_opt_tras_roadtype_id" : 0,
  "default_opt_tras_street" : "",
  "default_opt_tras_country_id" : 0,
  "default_opt_tras_province_id" : 0,
  "default_opt_tras_postalcode_id" : 0,
  "default_opt_tras_community_id" : 0,
  "default_opt_tras_phone" : "",
  "default_opt_tras_email" : "",
  "default_opt_tras_nima" : "",
  "default_opt_tras_cnae" : "",
  "default_opt_tras_inscription" : "",
  "default_opt_tras_opt" : "",
  "default_opt_tras_licenseplate" : "",
  "default_opt_tras_economicactivity" : "",
    
  "default_ori_tras_id" : 0,
  "default_ori_tras_documnettype_id" : 0,
  "default_ori_tras_documentid" : "",
  "default_ori_tras_tradename" : "",
  "default_ori_tras_name" : "",
  "default_ori_tras_contactname" : "",
  "default_ori_tras_roadtype_id" : 0,
  "default_ori_tras_street" : "",
  "default_ori_tras_country_id" : 0,
  "default_ori_tras_province_id" : 0,
  "default_ori_tras_postalcode_id" : 0,
  "default_ori_tras_community_id" : 0,
  "default_ori_tras_phone" : "",
  "default_ori_tras_email" : "",
  "default_ori_tras_nima" : "",
  "default_ori_tras_cnae" : "",
  "default_ori_tras_inscription" : "",
  "default_ori_tras_opt" : "",
  "default_ori_tras_licenseplate" : "",
  "default_ori_tras_economicactivity" : "",

  "default_aut_tras_id" : 0,
  "default_aut_tras_documnettype_id" : 0,
  "default_aut_tras_documentid" : "",
  "default_aut_tras_tradename" : "",
  "default_aut_tras_name" : "",
  "default_aut_tras_contactname" : "",
  "default_aut_tras_roadtype_id" : 0,
  "default_aut_tras_street" : "",
  "default_aut_tras_country_id" : 0,
  "default_aut_tras_province_id" : 0,
  "default_aut_tras_postalcode_id" : 0,
  "default_aut_tras_community_id" : 0,
  "default_aut_tras_phone" : "",
  "default_aut_tras_email" : "",
  "default_aut_tras_nima" : "",
  "default_aut_tras_cnae" : "",
  "default_aut_tras_inscription" : "",
  "default_aut_tras_opt" : "",
  "default_aut_tras_licenseplate" : "",
  "default_aut_tras_economicactivity" : "",

  "default_dest_tras_id" : 0,
  "default_dest_tras_documnettype_id" : 0,
  "default_dest_tras_documentid" : "",
  "default_dest_tras_tradename" : "",
  "default_dest_tras_name" : "",
  "default_dest_tras_contactname" : "",
  "default_dest_tras_roadtype_id" : 0,
  "default_dest_tras_street" : "",
  "default_dest_tras_country_id" : 0,
  "default_dest_tras_province_id" : 0,
  "default_dest_tras_postalcode_id" : 0,
  "default_dest_tras_community_id" : 0,
  "default_dest_tras_phone" : "",
  "default_dest_tras_email" : "",
  "default_dest_tras_nima" : "",
  "default_dest_tras_cnae" : "",
  "default_dest_tras_inscription" : "",
  "default_dest_tras_opt" : "",
  "default_dest_tras_licenseplate" : "",
  "default_dest_tras_economicactivity" : "",

  "default_aut_dest_id" : 0,
  "default_aut_dest_documnettype_id" : 0,
  "default_aut_dest_documentid" : "",
  "default_aut_dest_tradename" : "",
  "default_aut_dest_name" : "",
  "default_aut_dest_contactname" : "",
  "default_aut_dest_roadtype_id" : 0,
  "default_aut_dest_street" : "",
  "default_aut_dest_country_id" : 0,
  "default_aut_dest_province_id" : 0,
  "default_aut_dest_postalcode_id" : 0,
  "default_aut_dest_community_id" : 0,
  "default_aut_dest_phone" : "",
  "default_aut_dest_email" : "",
  "default_aut_dest_nima" : "",
  "default_aut_dest_cnae" : "",
  "default_aut_dest_inscription" : "",
  "default_aut_dest_opt" : "",
  "default_aut_dest_licenseplate" : "",
  "default_aut_dest_economicactivity" : "",
 
  "default_codeler_id" : 0,
  "default_codeler_code" : "",
  "default_codeler_namees" : "",
  "default_codeler_nameen" : "",
  "default_description_id" : 0,
  "default_description_code" : "",
  "default_description_namees" : "",
  "default_description_nameen" : "",
  "default_treatmenttypeorigin_id" : 0,
  "default_treatmenttypeorigin_code" : "",
  "default_treatmenttypeorigin_namees" : "",
  "default_treatmenttypeorigin_nameen" : "",
  "default_treatmenttypedestine_id" : 0,
  "default_treatmenttypedestine_code" : "",
  "default_treatmenttypedestine_namees" : "",
  "default_treatmenttypedestine_nameen" : "",
  "default_processtypeorigin_id" : 0,
  "default_processtypeorigin_code" : "",
  "default_processtypeorigin_namees" : "",
  "default_processtypeorigin_nameen" : "",
  "default_processtypedestine_id" : 0,
  "default_processtypedestine_code" : "",
  "default_processtypedestine_namees" : "",
  "default_processtypedestine_nameen" : "",
  "default_dangerousness_id" : 0,
  "default_dangerousness_namees" : "",
  "default_dangerousness_nameen" : "",

  "default_resp_prod_id" : 0,
  "default_resp_prod_documnettype_id" : 0,
  "default_resp_prod_documentid" : "",
  "default_resp_prod_tradename" : "",
  "default_resp_prod_name" : "",
  "default_resp_prod_contactname" : "",
  "default_resp_prod_roadtype_id" : 0,
  "default_resp_prod_street" : "",
  "default_resp_prod_country_id" : 0,
  "default_resp_prod_province_id" : 0,
  "default_resp_prod_postalcode_id" : 0,
  "default_resp_prod_community_id" : 0,
  "default_resp_prod_phone" : "",
  "default_resp_prod_email" : "",
  "default_resp_prod_nima" : "",
  "default_resp_prod_cnae" : "",
  "default_resp_prod_inscription" : "",
  "default_resp_prod_opt" : "",
  "default_resp_prod_licenseplate" : "",
  "default_resp_prod_economicactivity" : "",

  "default_rel_trans_id" : 0,
  "default_rel_trans_documnettype_id" : 0,
  "default_rel_trans_documentid" : "",
  "default_rel_trans_tradename" : "",
  "default_rel_trans_name" : "",
  "default_rel_trans_contactname" : "",
  "default_rel_trans_roadtype_id" : 0,
  "default_rel_trans_street" : "",
  "default_rel_trans_country_id" : 0,
  "default_rel_trans_province_id" : 0,
  "default_rel_trans_postalcode_id" : 0,
  "default_rel_trans_community_id" : 0,
  "default_rel_trans_phone" : "",
  "default_rel_trans_email" : "",
  "default_rel_trans_nima" : "",
  "default_rel_trans_cnae" : "",
  "default_rel_trans_inscription" : "",
  "default_rel_trans_opt" : "",
  "default_rel_trans_licenseplate" : "",
  "default_rel_trans_economicactivity" : "",
 
  "formatDIDTO":{
    "id" : 1,
    "typesdi_id" :1,
    "opt_tras_view" :true,
    "opt_tras_expand" :true,
    "opt_tras_handle" :true,
    "opt_tras_view_name" :true,
    "opt_tras_view_contactname" :true,
    "opt_tras_view_address" :true,
    "opt_tras_view_country" :true,
    "opt_tras_view_community" :true,
    "opt_tras_view_phone" :true,
    "opt_tras_view_email" :true,
    "opt_tras_view_nima" :true,
    "opt_tras_view_cnae" :false,
    "opt_tras_view_inscription" :true,
    "opt_tras_view_opt" :true,
    "opt_tras_view_licenseplate" :false,
    "opt_tras_view_economicactivity" :false,
    
    "opt_tras_handle_documnettype" :true,
    "opt_tras_handle_documentid" :true,
    "opt_tras_handle_tradename" :true,
    "opt_tras_handle_name" :true,
    "opt_tras_handle_contactname" :true,
    "opt_tras_handle_address" :true,
    "opt_tras_handle_phone" :true,
    "opt_tras_handle_email" :true,
    "opt_tras_handle_nima" :true,
    "opt_tras_handle_cnae" :false,
    "opt_tras_handle_inscription" :true,
    "opt_tras_handle_opt" :true,
    "opt_tras_handle_licenseplate" :false,
    "opt_tras_handle_economicactivity" :false,
    
    "ori_tras_view" :true,
    "ori_tras_expand" :true,
    "ori_tras_handle" :true,
    "ori_tras_view_name" :true,
    "ori_tras_view_contactname" :true,
    "ori_tras_view_address" :true,
    "ori_tras_view_country" :true,
    "ori_tras_view_community" :true,
    "ori_tras_view_phone" :true,
    "ori_tras_view_email" :true, 
    "ori_tras_view_nima" :true,
    "ori_tras_view_cnae" :true,
    "ori_tras_view_inscription" :true,
    "ori_tras_view_opt" :false,
    "ori_tras_view_licenseplate" :false,
    "ori_tras_view_economicactivity" :false,

    "ori_tras_handle_documnettype" :true,
    "ori_tras_handle_documentid" :true,
    "ori_tras_handle_tradename" :true,
    "ori_tras_handle_name" :true,
    "ori_tras_handle_contactname" :true,
    "ori_tras_handle_address" :true,
    "ori_tras_handle_phone" :true,
    "ori_tras_handle_email" :true,
    "ori_tras_handle_nima" :true,
    "ori_tras_handle_cnae" :true,
    "ori_tras_handle_inscription" :true,
    "ori_tras_handle_opt" :false,
    "ori_tras_handle_licenseplate" :false,
    "ori_tras_handle_economicactivity" :false,

    "aut_tras_view" :true,
    "aut_tras_expand" :true,
    "aut_tras_handle" :true,
    "aut_tras_view_name" :true,
    "aut_tras_view_contactname" :true,
    "aut_tras_view_address" :true,
    "aut_tras_view_country" :true, 
    "aut_tras_view_community" :true,
    "aut_tras_view_phone" :true,
    "aut_tras_view_email" :true,
    "aut_tras_view_nima" :true,
    "aut_tras_view_cnae" :false,
    "aut_tras_view_inscription" :true,
    "aut_tras_view_opt" :false,
    "aut_tras_view_licenseplate" :false,
    "aut_tras_view_economicactivity" :false,

    "aut_tras_handle_documnettype" :true,
    "aut_tras_handle_documentid" :true,
    "aut_tras_handle_tradename" :true,
    "aut_tras_handle_name" :true,
    "aut_tras_handle_contactname" :true,
    "aut_tras_handle_address" :true,
    "aut_tras_handle_phone" :true,
    "aut_tras_handle_email" :true,
    "aut_tras_handle_nima" :true,
    "aut_tras_handle_cnae" :false,
    "aut_tras_handle_inscription" :true,
    "aut_tras_handle_opt" :false,
    "aut_tras_handle_licenseplate" :false,
    "aut_tras_handle_economicactivity" :false,

    "dest_tras_view" :true,
    "dest_tras_expand" :true,
    "dest_tras_handle" :true,
    "dest_tras_view_name" :true,
    "dest_tras_view_contactname" :true,
    "dest_tras_view_address" :true,
    "dest_tras_view_country" :true, 
    "dest_tras_view_community" :true,
    "dest_tras_view_phone" :true,
    "dest_tras_view_email" :true,
    "dest_tras_view_nima" :true,
    "dest_tras_view_cnae" :false,
    "dest_tras_view_inscription" :true,
    "dest_tras_view_opt" :false,
    "dest_tras_view_licenseplate" :false,
    "dest_tras_view_economicactivity" :false,

    "dest_tras_handle_documnettype" :true,
    "dest_tras_handle_documentid" :true,
    "dest_tras_handle_tradename" :true,
    "dest_tras_handle_name" :true,
    "dest_tras_handle_contactname" :true,
    "dest_tras_handle_address" :true,
    "dest_tras_handle_phone" :true,
    "dest_tras_handle_email" :true,
    "dest_tras_handle_nima" :true,
    "dest_tras_handle_cnae" :false,
    "dest_tras_handle_inscription" :true,
    "dest_tras_handle_opt" :false,
    "dest_tras_handle_licenseplate" :false,
    "dest_tras_handle_economicactivity" :false,
  
    "aut_dest_view" :true,
    "aut_dest_expand" :true,
    "aut_dest_handle" :true,
    "aut_dest_view_name" :true,
    "aut_dest_view_contactname" :true,
    "aut_dest_view_address" :true,
    "aut_dest_view_country" :true, 
    "aut_dest_view_community" :true,
    "aut_dest_view_phone" :true,
    "aut_dest_view_email" :true,
    "aut_dest_view_nima" :true,
    "aut_dest_view_cnae" :false,
    "aut_dest_view_inscription" :true,
    "aut_dest_view_opt" :false,
    "aut_dest_view_licenseplate" :false,
    "aut_dest_view_economicactivity" :false,

    "aut_dest_handle_documnettype" :true,
    "aut_dest_handle_documentid" :true,
    "aut_dest_handle_tradename" :true,
    "aut_dest_handle_name" :true,
    "aut_dest_handle_contactname" :true,
    "aut_dest_handle_address" :true,
    "aut_dest_handle_phone" :true,
    "aut_dest_handle_email" :true,
    "aut_dest_handle_nima" :true,
    "aut_dest_handle_cnae" :false,
    "aut_dest_handle_inscription" :true,
    "aut_dest_handle_opt" :false,
    "aut_dest_handle_licenseplate" :false,
    "aut_dest_handle_economicactivity" :false,

    "rel_trans_view" :true,
    "rel_trans_expand" :true,
    "rel_trans_handle" :true,
    "rel_trans_view_name" :true,
    "rel_trans_view_contactname" :true,
    "rel_trans_view_address" :true,
    "rel_trans_view_country" :true, 
    "rel_trans_view_community" :true,
    "rel_trans_view_phone" :true,
    "rel_trans_view_email" :true,
    "rel_trans_view_nima" :true,
    "rel_trans_view_cnae" :false,
    "rel_trans_view_inscription" :true,
    "rel_trans_view_opt" :false,
    "rel_trans_view_licenseplate" :true,
    "rel_trans_view_economicactivity" :false,

    "rel_trans_handle_documnettype" :true,
    "rel_trans_handle_documentid" :true,
    "rel_trans_handle_tradename" :true,
    "rel_trans_handle_name" :true,
    "rel_trans_handle_contactname" :true,
    "rel_trans_handle_address" :true,
    "rel_trans_handle_phone" :true,
    "rel_trans_handle_email" :true,
    "rel_trans_handle_nima" :true,
    "rel_trans_handle_cnae" :false,
    "rel_trans_handle_inscription" :true,
    "rel_trans_handle_opt" :false,
    "rel_trans_handle_licenseplate" :true,
    "rel_trans_handle_economicactivity" :false,

    "resp_prod_view" :true,
    "resp_prod_expand" :true,
    "resp_prod_handle" :true,
    "resp_prod_view_name" :true,
    "resp_prod_view_contactname" :true,
    "resp_prod_view_address" :true,
    "resp_prod_view_country" :true, 
    "resp_prod_view_community" :true,
    "resp_prod_view_phone" :true,
    "resp_prod_view_email" :true,
    "resp_prod_view_nima" :true,
    "resp_prod_view_cnae" :false,
    "resp_prod_view_inscription" :true,
    "resp_prod_view_opt" :false,
    "resp_prod_view_licenseplate" :false,
    "resp_prod_view_economicactivity" :false,

    "resp_prod_handle_documnettype" :true,
    "resp_prod_handle_documentid" :true,
    "resp_prod_handle_tradename" :true,
    "resp_prod_handle_name" :true,
    "resp_prod_handle_contactname" :true,
    "resp_prod_handle_address" :true,
    "resp_prod_handle_phone" :true,
    "resp_prod_handle_email" :true,
    "resp_prod_handle_nima" :true,
    "resp_prod_handle_cnae" :false,
    "resp_prod_handle_inscription" :true,
    "resp_prod_handle_opt" :false,
    "resp_prod_handle_licenseplate" :false,
    "resp_prod_handle_economicactivity" :false,

    "number_dt_view" :true,
    "code_description_view" :true,
    "code_treatmenttype_origin_view" :false,
    "code_treatmenttype_destine_view" :true,
    "code_processtype_origin_view" :false,
    "code_processtype_destine_view" :false,
    "code_dangerousness_view" :true,
    "charac_danger_view" :false,
    "date_refund_view" :false,
    "reason_refund_view" :false,
    "action_refund_view" :false,
    "number_dt_handle" :true,
    "code_description_handle" :true,
    "code_treatmenttype_origin_handle" :false,
    "code_treatmenttype_destine_handle" :true,
    "code_processtype_origin_handle" :false,
    "code_processtype_destine_handle" :false,
    "code_dangerousness_handle" :true,
    "charac_danger_handle" :false,
    "date_refund_handle" :false,
    "reason_refund_handle" :false,
    "action_refund_handle" :false,

    "share_form_opt_tras" :false,
    "share_form_ori_tras" :false,
    "share_form_aut_tras" :false,
    "share_form_dest_tras" :false,
    "share_form_aut_dest" :false,
    "share_form_rel_trans" :false,
    "share_form_resp_prod" :false,

    "sendbyemail_form_view":false,
    "sendbyemail_form_handle" :false,
    "sendbyemail_form_opt_tras" :false,
    "sendbyemail_form_ori_tras" :false,
    "sendbyemail_form_aut_tras" :false,
    "sendbyemail_form_dest_tras" :false,
    "sendbyemail_form_aut_dest" :false,
    "sendbyemail_form_rel_trans" :false,
    "sendbyemail_form_resp_prod" :false,

    "filenameexcel":"",
    "delete_code":"",
    "delete_code_employee":"",
    "delete_code_store":"",
    "delete_code_formdi":"",
    "default_ext_phone":1,
    "default_country":1,
    "default_country_name":"",
    "default_province":31,
    "default_province_name":"",
    "default_postalcode":0,
    "default_postalcode_code":"3500A",
    "default_postalcode_name":"",
    "default_community":6,
    "default_community_name":"",
    "default_roadtype":74,
    "default_roadtype_name":"",
    "default_documenttype":1,
    "default_documenttype_name":"",

    "limitphoneperstore":5,
    "limitemailperstore":5,
    "limitaddressperstore":15,
    "limitbankaccountperstore":5,
    "limitphoneperemployee":5,
    "limitemailperemployee":5,
    "limitaddressperemployee":5,
    "limitbankaccountperemployee":5,
    "signature_default":"",
    "signature_default_des_tras":"",

    "share_esir_form_opt_tras" :false,
    "share_esir_form_ori_tras" :false,
    "share_esir_form_aut_tras" :false,
    "share_esir_form_dest_tras" :false,
    "share_esir_form_aut_dest" :false,
    "share_esir_form_rel_trans" :false,
    "share_esir_form_resp_prod" :false,

    "share_email_form_opt_tras" :false,
    "share_email_form_ori_tras" :false,
    "share_email_form_aut_tras" :false,
    "share_email_form_dest_tras" :false,
    "share_email_form_aut_dest" :false,
    "share_email_form_rel_trans" :false,
    "share_email_form_resp_prod" :false,

    "sendemail_ended_form_opt_tras" :false,
    "sendemail_ended_form_ori_tras" :false,
    "sendemail_ended_form_aut_tras" :false,
    "sendemail_ended_form_dest_tras" :false,
    "sendemail_ended_form_aut_dest" :false,
    "sendemail_ended_form_rel_trans" :false,
    "sendemail_ended_form_resp_prod" :false,
  }
}];

const TypesDIsFilter = ({applyFilters, setApplyFilters,showModalTypesDISettings,setShowModalTypesDISettings}) => {
  
  const {t} = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const [data, setData] = useState(initialState); 
  const [filters, setFilters] = useState(applyFilters);
  const [numTotReg, setNumTotReg] = useState(0);
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [errorsFilters, setErrorsFilters] = useState({});
  const [inputText, setInputText] = useState(""); 
  const [openDeleteRow, setOpenDeleteRow] = useState(false);
  const [openEditRow, setOpenEditRow] = useState(false);
  const [openEditFilter, setOpenEditFilter] = useState(false);
  const [rowEdit, setRowEdit] = useState(initialState[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [idCodeDelete, setIdCodeDelete] = useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffset, setActiveOffset] = useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(0);
  const [rangeOffset, setRangeOffset] = useState([{}]);
  const [openCreateFormatDI,setOpenCreateFormatDI]=useState(false);   
  const [openCreateFormatDetailsDI,setOpenCreateFormatDetailsDI]=useState(false);   
  const [openCreateFormatGeneralDI,setOpenCreateFormatGeneralDI]=useState(false);   

  const navigate = useNavigate(); 

  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && showModalTypesDISettings) {
        setData(initialState); 
        setFilters(initialFilters);
        setNumTotReg(0);
        setNumTotRegFilter(0);
        setErrorsFilters({}); 
        setInputText(""); 
        setOpenDeleteRow(false);
        setOpenEditRow(false);
        setOpenEditFilter(false);
        setRowEdit(initialState[0]);
        dispatch(setLoading(false));
        setIsLoadingError(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffset(false);
        setCurrencyOffset(0);
        setRangeOffset([{}]);
        setOpenCreateFormatDI(false); 
        setOpenCreateFormatDetailsDI(false);
        setOpenCreateFormatGeneralDI(false);
        setShowModalTypesDISettings(false);
        setApplyFilters(initialFilters);
        navigate("/home");
        return () => {};
      }
    },
    [
      setData,
      setFilters,
      setNumTotReg,
      setNumTotRegFilter,
      setErrorsFilters, 
      setInputText, 
      setOpenDeleteRow,
      setOpenEditRow,
      setOpenEditFilter,
      setRowEdit, 
      setIsLoadingError,
      setIdCodeDelete,
      setActiveOffset,
      setCurrencyOffset,
      setRangeOffset,
      setOpenCreateFormatDI,  
      setOpenCreateFormatDetailsDI,
      setOpenCreateFormatGeneralDI,
      setApplyFilters,
      showModalTypesDISettings, 
      setShowModalTypesDISettings, 
      DELETE_CODE,
      dispatch,
      navigate
    ]
  );

  const closeModalTypesDISettings = () => {    
    setData(initialState); 
    //setForm(initialState[0]);
    setFilters(initialFilters);
    setNumTotReg(0);
    setNumTotRegFilter(0);
    setErrorsFilters({}); 
    setInputText(""); 
    setOpenDeleteRow(false);
    setOpenEditRow(false);
    setOpenEditFilter(false);
    setRowEdit(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setActiveOffset(false);
    setCurrencyOffset(0);
    setRangeOffset([{}]);
    setOpenCreateFormatDI(false);
    setOpenCreateFormatDetailsDI(false);
    setOpenCreateFormatGeneralDI(false);
    setShowModalTypesDISettings(false);
    setApplyFilters(initialFilters);
    navigate("/home");
    return () => {};
  };

  const openCreateOrEditData = () => {
    setInputText(""); 
    navigate("/formatdidetail/0");
  };

   const openEditFilters = () => {
    setFilters(applyFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleSubmitFilterEdit = () => {
    setErrorsFilters(validateFormFilter());
    if (Object.keys(errorsFilters).length === 0) {
      setApplyFilters(filters);
      setFilters(initialFilters);
      setErrorsFilters({});
      setOpenEditFilter(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  
  const handleDeleteFilters = () => {
    setErrorsFilters({});
    setFilters(initialFilters);
    setApplyFilters(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleCancelFilters = () => {
    setErrorsFilters({});
    setFilters(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleChangeFilterEdit = (e) => {
    const { name, value } = e.target;
    setFilters(filters => ({
      ...filters,
      [name]: value
    }));
  };

  const handleBlurFilterEdit = (e) => {
    setErrorsFilters(validateFormFilter());
    handleChangeFilterEdit(e);
  };

  const toggleDrawerFilterEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      closeModalTypesDISettings();
    }
  };

  const validateFormFilter = () => {

    let errorsFilters = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filters.idFrom!=="" & !regexNumber.test(filters.idFrom)) {
      errorsFilters.idFrom = 'Text_TextNoNumber';
    }
    if (filters.idTo!=="" & !regexNumber.test(filters.idTo)) {
      errorsFilters.idTo = 'Text_TextNoNumber';
    }
     
    if (filters.idFrom!=="" & !errorsFilters.idFrom!==undefined){
      if (filters.idTo!=="" & !errorsFilters.idTo!==undefined){
        if (parseInt(filters.idTo)<parseInt(filters.idFrom)){
          errorsFilters.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filters.nameesFrom)) {
      errorsFilters.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.nameesTo)) {
      errorsFilters.nameesTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.nameenFrom)) {
      errorsFilters.nameenFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filters.nameenTo)) {
      errorsFilters.nameenTo = 'Text_TextNoValid';
    } 
    if (filters.nameesTo!=="" & filters.nameesTo<filters.nameesFrom){
      errorsFilters.nameesTo = 'Text_TextGreater_Namees';
    }
    if (filters.nameenTo!=="" & filters.nameenTo<filters.nameenFrom){
      errorsFilters.nameenTo = 'Text_TextGreater_Nameen';
    }
    return errorsFilters;
  }  

  const filteredData = data.filter((el) => {
    if (inputText === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.namees || '') + 
        String(el.nameen || '');
      let result = dataTranslate.toLowerCase().includes(inputText.toLowerCase());
      return result;
    }
  })
  
  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRow = () => {
    setRowEdit(initialState[0]);
    dispatch(setLoading(false)); 
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
  };

  const handleCloseDeleteRow = (e) => {
    if (idCodeDelete !== DELETE_CODE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
  
    if (e.key !== 'Escape') {
      if (rowEdit.id !== '') {
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `typesdi/deletetypesdi`, token, rowEdit);
            if (getData.status === "OK") {
              dispatch(successErrorAction(t('Text_ValidCode')));
              dispatch(successErrorAction(t('Text_DeleteField')));
            } else {
              dispatch(warningErrorAction(t(getData.cause)));
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData();
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    } 
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
    handleCloseDataEdit();
  };
  
  const handleCloseDataEdit = () => { 
    setOpenEditRow(false);
    setRowEdit(openEditRow?rowEdit:initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    toggleDrawerFilterEdit(false);
	};
   
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
  useEffect(() => {
    if (numTotRegFilter > LIMITPAGESIZE) {
      setActiveOffset(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMITPAGESIZE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMITPAGESIZE); i < numTotRegFilter; i += Number(LIMITPAGESIZE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMITPAGESIZE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffset(newRangeOffset);
    } else {
      setCurrencyOffset(0);
      setActiveOffset(false);
      setRangeOffset([{}]);
    }
  }, [numTotRegFilter,LIMITPAGESIZE]);
 
  useEffect(() => {
    let ignore = false;
    const fetchnumTotReg = async () => { 
      try {
        const getData = await helpHttp().get(ENDPOINT, `typesdi/getinformationtabletypesdi`, token);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotReg(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `typesdi/getcountfiltertypesdis`, token, applyFilters);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT, `typesdi/typesdis`, token, currencyOffset, LIMITPAGESIZE, applyFilters);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setData(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    }; 
    if (showModalTypesDISettings){
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchData();;
    return () => { ignore = true };
    }
  }, [t,token,dispatch,openDeleteRow,openEditRow,rowEdit,showModalTypesDISettings,applyFilters,currencyOffset,LIMITPAGESIZE]);
  return (
    <div> 
      { showModalTypesDISettings && 
        <div className="container-fluid formdi-pending-page">
          {/* Search input */}
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingError?
              <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>
              :isLoadingData? 
              <CircularProgress color={openDeleteRow?"warning":"primary"}/>:
              <i className="fas fa-solid fa-align-justify text-warning"></i>} {t('Text_TypesDI_Config')}
            </h1>
            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_TypesDi_Create')) ?
                <div>
                  <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditData} >
                    {t('Button_Create')}
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalTypesDISettings} >
                    {t("Button_Back")}
                  </button> 
                </div>:
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalTypesDISettings} >
                  {t("Button_Back")}
                </button>
                
              }
          </div>  
          <br/> 
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputText}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_TypesDI_Search')} 
              onChange={inputHandler}
              fullWidth
              label={t('Text_TypesDI_Search')}>
            </TextField>
          </div>
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${applyFilters.idFrom !== "" || applyFilters.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ applyFilters.idFrom !== "" || applyFilters.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              <button type="button" className={`formdi-pending-chip ${applyFilters.nameesFrom !== "" || applyFilters.nameesFrom !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ applyFilters.nameesFrom !== "" || applyFilters.nameesFrom !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_NameEs")}
              </button>
              <button type="button" className={`formdi-pending-chip ${applyFilters.nameenFrom !== "" || applyFilters.nameenFrom !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ applyFilters.nameenFrom !== "" || applyFilters.nameenFrom !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_NameEn")}
              </button> 
            </div>
          </div>
          <br/>
          <div className="formdi-pending-card-flat">
            <div className="formdi-pending-card-content">
              <TableSorting
                data={filteredData}
                numTotRegFilter={numTotRegFilter}
                titleTable={t('Text_TypesDI_Table')}
                setOpenDeleteRow={setOpenDeleteRow}
                setOpenCreateFormatDI={setOpenCreateFormatDI}
                setOpenCreateFormatDetailsDI={setOpenCreateFormatDetailsDI}
                setOpenCreateFormatGeneralDI={setOpenCreateFormatGeneralDI}
                setRowEdit={setRowEdit}
                showEditButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_TypesDi_Edit'))?true:false}
                showDeleteButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_TypesDi_Delete'))?true:false}
                showVisibilityButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_TypesDi_Delete'))?true:false}
                numTotReg={numTotReg}
                activeOffset={activeOffset}
                rangeOffset={rangeOffset}
                currencyOffset={currencyOffset}
                setCurrencyOffset={setCurrencyOffset}
                minvalue={Number(NON_ERASABLE_TYPESDI_ID)}
              >
              </TableSorting>
            </div>             
          </div>
          {openEditFilter &&
            <div>
              <SwipeableDrawer
                anchor='right'
                open={true}
                onClose={toggleDrawerFilterEdit(false)}
                onOpen={toggleDrawerFilterEdit(true)}>
                <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '600px' }}>
                     <br/>
                    <div id="myDIV">
                       <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                    </div>
                    <hr className="sidebar-divider d-none d-md-block"/>
                    <form className="createfiltercontract" onSubmit={handleCancelFilters}>  
                      <div className="form-floating mb-3 px-4 primary">
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Code_From')} :</label>
                        <div className="form-group">
                          <TextField
                            id="idFrom" 
                            name="idFrom"
                            value={filters.idFrom}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 15 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsFilters.idFrom!=null?t(errorsFilters.idFrom):t('PlaceHolder_Filter_Code_From')}
                            placeholder={t('PlaceHolder_Filter_Code_From')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Code_To')} :</label>
                        <div className="form-group">
                          <TextField
                            id="idTo" 
                            name="idTo"
                            value={filters.idTo}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 15 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsFilters.idTo!=null?t(errorsFilters.idTo):t('PlaceHolder_Filter_Code_to')}
                            placeholder={t('PlaceHolder_Filter_Code_to')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>

                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEs_From')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameesFrom" 
                            name="nameesFrom"
                            value={filters.nameesFrom}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsFilters.nameesFrom!=null?t(errorsFilters.nameesFrom):t('PlaceHolder_Filter_NameEs_From')}
                            placeholder={t('PlaceHolder_Filter_NameEs_From')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEs_To')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameesTo" 
                            name="nameesTo"
                            value={filters.nameesTo}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsFilters.nameesTo!=null?t(errorsFilters.nameesTo):t('PlaceHolder_Filter_NameEs_to')}
                            placeholder={t('PlaceHolder_Filter_NameEs_to')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>

                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEn_From')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameenFrom" 
                            name="nameenFrom"
                            value={filters.nameenFrom}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsFilters.nameenFrom!=null?t(errorsFilters.nameenFrom):t('PlaceHolder_Filter_NameEn_From')}
                            placeholder={t('PlaceHolder_Filter_NameEn_From')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_NameEn_To')} :</label>
                        <div className="form-group">
                          <TextField
                            id="nameenTo" 
                            name="nameenTo"
                            value={filters.nameenTo}
                            inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsFilters.nameenTo!=null?t(errorsFilters.nameenTo):t('PlaceHolder_Filter_NameEn_to')}
                            placeholder={t('PlaceHolder_Filter_NameEn_to')}
                            variant="standard"
                            onBlur={handleBlurFilterEdit}
                            onChange={handleChangeFilterEdit}/>
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEdit}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFilters}>
                              {t('Button_Cancel_Filters')}
                            </button>
                         </div>
                      </div>
                    </form>
                  </Box>
                </Container>
              </SwipeableDrawer>
            </div>
          }  
           <FormatGeneralDISettings 
            openCreateFormatGeneralDI={openCreateFormatGeneralDI}
            setOpenCreateFormatGeneralDI={setOpenCreateFormatGeneralDI} 
            rowEdit={rowEdit}
            setRowEdit={setRowEdit}
            titlees={rowEdit.namees}
            titleen={rowEdit.nameen}
          />
        
           <FormatDISettings 
            openCreateFormatDI={openCreateFormatDI}
            setOpenCreateFormatDI={setOpenCreateFormatDI} 
            rowEdit={rowEdit}
            setRowEdit={setRowEdit}
            titlees={rowEdit.namees}
            titleen={rowEdit.nameen}
          />
           <FormatDetailsDISettings 
            openCreateFormatDetailsDI={openCreateFormatDetailsDI}
            setOpenCreateFormatDetailsDI={setOpenCreateFormatDetailsDI} 
            rowEdit={rowEdit}
            setRowEdit={setRowEdit}
            titlees={rowEdit.namees}
            titleen={rowEdit.nameen}
          /> 
          <Dialog open={openDeleteRow} onClose={handleCancelDeleteRow} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {t('Text_Delete')} {rowEdit.id}  - {rowEdit.namees} - {rowEdit.nameen}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRow}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRow}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRow}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog>  
          {/* End Content Row */}
        </div>
        //* End Page Content *//
      }
     </div>
  )
}

TypesDIsFilter.propTypes = {
  applyFilters: PropTypes.object.isRequired,
  setApplyFilters: PropTypes.func.isRequired,
  showModalTypesDISettings: PropTypes.bool.isRequired,
  setShowModalTypesDISettings: PropTypes.func.isRequired 
};
  
export default TypesDIsFilter;
